import React, {useEffect, useRef, useState} from "react";
import {
  Button,
  Col,
  Descriptions,
  QRCode,
  Row,
  Space,
  Spin,
  Typography,
} from "antd";
import ReactToPrint from "react-to-print";
import {FORMAT_TIME} from "types/enums";
import {birthday2Age, formatDateToString, getAge} from "helper/common";
import Notification from "components/common/notification/notification";
import Sign from "components/common/PrintForm/Sign/Sign";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {Document, Page, pdfjs} from "react-pdf";
import axiosClient from "api/axiosClient";
import diagnose from "api/diagnose";
import {setIsCallResultDiagnose} from "redux/reducer/diagnose";
import "./style.scss";
import {HeaderPrintForm, InfoItem} from "components/common/PrintForm";
import SearchPatientService from "api/searchPatient";

//pass error "WorkerMessageHandler"
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const DiagnoseModal = props => {
  const dispatch = useAppDispatch();
  const printRef = useRef<any>();
  const {closeModal} = props;
  const isCallResultDiagnose = useAppSelector(
    e => e.diagnose.isCallResultDiagnose
  );
  const idDiagnose = useAppSelector(e => e.diagnose.idDiagnose);

  const activetab = useAppSelector(e => e.common.activeTab);
  const [receiptDetails, setReceiptDetails] = useState(null);
  const dataDiagnose = useAppSelector(e => e.diagnose.data);

  const [numPages, setNumPages] = useState<number>();
  const [loading, setLoading] = useState<boolean>(false);
  const [filePdf, setFilePdf] = useState<File | string | object>({});

  const onPrint = async () => {
    window.print();
  };

  const getPrintDiagnose = async () => {
    setLoading(true);
    try {
      const url = `/search/phieu-cdha-in?id=${idDiagnose}`;
      const res = await axiosClient.get(url, {responseType: "blob"});
      const data = res.data;
      const blob = new Blob([data], {type: "application/pdf"});
      setFilePdf(blob);
      setLoading(false);
    } catch (error) {
      if (error.response.status === 400) {
        setFilePdf(null);
        Notification("warning", "Chưa có thông tin file pdf");
      } else Notification("error", "Đã xảy ra lỗi khi lấy file kết quả.");
      setLoading(false);
      setFilePdf(null);
    }
  };
  const getDetailPatient = async () => {
    setLoading(true);
    try {
      const res = await SearchPatientService.getDetailsDiagnoseById(idDiagnose);
      setReceiptDetails(res);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã xảy ra lỗi khi lấy thông tin bệnh nhân");
    }
  };

  useEffect(() => {
    if (idDiagnose !== null) {
      if (isCallResultDiagnose) {
        getPrintDiagnose();
      }
      getDetailPatient();
    }
  }, [idDiagnose, dataDiagnose, isCallResultDiagnose]);

  const fields1 = [
    {label: "Họ và tên", value: receiptDetails?.hoTen},
    {
      label: "Ngày sinh - Tuổi",
      value: `${formatDateToString(
        receiptDetails?.ngaySinh,
        FORMAT_TIME.dayFull
      )}`,
    },
    {
      label: "Giới tính",
      value: receiptDetails?.gioiTinh == 0 ? "Nam" : "Nữ",
    },
    {label: "Điện thoại", value: receiptDetails?.dienThoai},
    // { label: "Địa chỉ", value: receiptDetails?.diaChiTongHop },
  ];
  const fields2 = [
    {label: "Mã bệnh nhân", value: receiptDetails?.maBenhNhan},

    {
      label: "Thời gian thực hiện từ",
      value: formatDateToString(
        receiptDetails?.thoiGianThucHienTu,
        FORMAT_TIME.dateTime
      ),
    },
    {
      label: "Thời gian thực hiện đến",
      value: formatDateToString(
        receiptDetails?.thoiGianThucHienDen,
        FORMAT_TIME.dateTime
      ),
    },
    {label: "Số BHYT", value: receiptDetails?.maTheBhyt},
    // {
    //   label: "Chẩn đoán",
    //   value: receiptDetails?.chanDoan,
    // },
  ];

  const onLoadPageDocument = (pdf: {numPages: number}) => {
    setNumPages(pdf.numPages);
    setLoading(false);
  };

  return (
    <div className="print-form-cdha">
      <Spin spinning={loading}>
        <div className="diagnose-print" ref={printRef}>
          <HeaderPrintForm />
          <div className="content-sub">
            <InfoItem
              fields1={fields1}
              fields2={fields2}
              idBenhNhan={receiptDetails?.maBenhNhan}
              title={"PHIẾU KẾT QUẢ CHẨN ĐOÁN HÌNH ẢNH"}
              isChiefComplant={false}
              isChanDoan={true}
              chanDoanValue={receiptDetails?.chanDoan}
              address={receiptDetails?.diaChiTongHop}
              spanLeft={10}
              spanRight={14}
            />

            <div className="content2">
              <Document
                noData={"không có data"}
                loading={loading}
                onLoadSuccess={onLoadPageDocument}
                onLoadError={error => {
                  setLoading(false);
                  Notification("error", "Đã xảy ra lỗi khi tải file pdf");
                }}
                file={filePdf as Blob}
              >
                {Array.from(new Array(numPages), (el, index) => (
                  <Page
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                  />
                ))}
              </Document>
            </div>

            <Sign
              name="Bác sĩ chuyên khoa"
              subLabel={false}
              nguoiThucHien={receiptDetails?.nvThucHien ?? ""}
              time={receiptDetails?.ngayTao}
            />
          </div>
        </div>
        <Row justify={"end"} className="footer">
          <Space direction="horizontal">
            <Button
              danger
              onClick={() => {
                closeModal();
                dispatch(setIsCallResultDiagnose(false));
              }}
            >
              Hủy
            </Button>
            <ReactToPrint
              trigger={() => {
                return (
                  <Button type="primary" onClick={onPrint}>
                    In
                  </Button>
                );
              }}
              content={() => printRef.current}
              bodyClass="print-form-cdha"
              onAfterPrint={closeModal}
            />
          </Space>
        </Row>
      </Spin>
    </div>
  );
};

export default DiagnoseModal;
